/* Copyright (c) 2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Spacer, theme } from "@nordcloud/gnui";
import {
  FilterHeader,
  Mode,
  getSelectedMode,
} from "~/components/SidebarWithMultiSelect";
import { isNotEmpty, noop } from "~/tools";
import { TagsInput } from "./TagsInput";

type Props = {
  inputTags?: string[];
  onChange: (tags: string[]) => void;
  placeholderName: string;
  isExcludeSelected?: boolean;
  onModeChange?: (mode: Mode) => void;
};

export function MultiTagsInput({
  inputTags,
  onChange,
  placeholderName,
  isExcludeSelected,
  onModeChange,
}: Props) {
  return (
    <>
      <FilterHeader
        allowModeChange
        defaultMode={getSelectedMode(isExcludeSelected)}
        onSetSearch={noop}
        onModeChange={onModeChange}
        noLeftPadding
      />
      <Spacer height={theme.spacing.spacing04} />
      <TagsInput
        showIcon
        inputTags={isNotEmpty(inputTags ?? []) ? inputTags : [""]}
        width="14rem"
        placeholder={{
          key: `${placeholderName} Key`,
          value: `${placeholderName} Value`,
        }}
        onChange={onChange}
      />
    </>
  );
}
